/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EntryScheduleItem} from "../../models/schedule/EntryScheduleItem";

/**
 * Generated class for the RoutineListItem component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'routine-list-item',
  templateUrl: 'routine-list-item.html',
})
export class RoutineListItem {

  @Input()
  item: EntryScheduleItem;

  @Output()
  onSelectEntry: EventEmitter<EntryScheduleItem> = new EventEmitter();

  constructor() {
    // console.log('Hello RoutineListItem Component');
  }

  select() {
    this.onSelectEntry.emit(this.item);
  }

}



// WEBPACK FOOTER //
// ./src/components/routine-list-item/routine-list-item.ts